const features = [
  {
    icon: 'ri-radio-line',
    title: 'Radios',
    description: 'Perfil público profesional, frecuencia RFW exclusiva, transmisión en vivo, programación y panel de control completo.',
  },
  {
    icon: 'ri-mic-line',
    title: 'Locutores',
    description: 'Perfiles verificados, seguidores, interacción con oyentes, programas destacados y reconocimiento en la comunidad.',
  },
  {
    icon: 'ri-calendar-check-line',
    title: 'Programas',
    description: 'Cada programa tiene su propio espacio, seguidores, ranking y club de fans. Los programas pueden ser más famosos que la radio.',
  },
  {
    icon: 'ri-group-line',
    title: 'Clubes de Fans',
    description: 'El corazón social de cada frecuencia. Publicaciones, retos, rankings internos, eventos y competencias entre clubes.',
  },
  {
    icon: 'ri-trophy-line',
    title: 'Competencias y Rankings',
    description: 'Radio vs Radio, Programa vs Programa. Rankings RFW Score en tiempo real y Hall of Fame de campeones históricos.',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Oyentes',
    description: 'Perfil social, niveles, insignias, rachas y logros. Cada interacción suma puntos. Los oyentes son protagonistas, no solo audiencia.',
  },
];

export default function AboutSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
            <i className="ri-group-line text-xs"></i>
            El Ecosistema Social
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 tracking-tight">
            La red social donde{' '}
            <span className="text-primary-600">la radio es comunidad</span>
          </h2>
          <p className="mt-4 text-foreground-500 text-base max-w-2xl mx-auto leading-relaxed">
            RadioFrecuenciaWeb es <strong>la comunidad de radio más grande del mundo.</strong> No es un directorio de estaciones ni un servicio de streaming. Es el ecosistema social donde radios, locutores, programas, clubes y oyentes hacen comunidad — con competencias, rankings, gamificación y conexión en tiempo real. El audio es solo el principio. La comunidad siempre será el producto principal.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group bg-background-50 rounded-2xl p-6 border border-background-200/80 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300 mb-4">
                <i className={`${feature.icon} text-lg`}></i>
              </div>
              <h3 className="font-semibold text-foreground-950 text-base mb-2">{feature.title}</h3>
              <p className="text-foreground-500 text-sm leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}